<template>
  <div class="combobox-vue-special select-search">
    <div class="content-checks" v-click-outside="onClose">
      <div @click="show = true" class="text-aux">
        <div class="content-text">
          <p>
            {{ getPlaceholder() }}
          </p>
        </div>
      </div>
      <ul v-show="show" ref="listado" class="items-list">
        <li v-if="opciones.length === 0" class="item">
          <div>
            <p style="padding-left: 10px">No hay resultados</p>
          </div>
        </li>
        <li v-for="item in opciones"
          class="item"
            :class="{active: isSelected(item)}"
          v-on:click="setSelected(item)"
          v-bind:key="item.id">
          <div>
            <label class="checkbox-item">
              <input :checked="isSelected(item)" type="checkbox" />
              <span></span>
            </label>
            <p>
              {{ item.nombre }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: null,
    opciones: Array,
    value: Array
  },
  data() {
    return {
      show: false,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   new PerfectScrollbar(this.$refs.listado, {
    //     useBothWheelAxes: false,
    //     suppressScrollX: false,
    //     suppressScrollY: true,
    //   })
    // })

  },
  // computed: {
  //   elementsFiltrados: function () {
  //     let vue = this
  //     return this.datos.filter(function (dt) {
  //       return dt.titulo.toLowerCase().indexOf(vue.filtro.toLowerCase()) !== -1
  //     })
  //   },
  // },
  methods: {
    isSelected(item){
      return this.value != null && this.value.indexOf(item.id) > -1
    },
    onClose() {
      if (this.show) {
        this.show = false
        // this.filtro = this.selected !== null ? this.selected.titulo : ''
        // if (this.changeBool) {
        //   this.$emit('changefinal')
        // }
        // this.changeBool = false
      }
    },
    // change() {
    //   this.$emit('change')
    //   this.changeBool = true
    // },
    // setData(data) {
    //   this.datos = data
      // this.generatePlaces()
      // this.change();
    // },
    getPlaceholder(){
      if(this.value == null || this.value.length === 0){
        return this.placeholder
      }
      let selected = this.getSelecteds()
      return selected.map(item => item.nombre).join(", ")
    },
    getSelecteds(){
      if(this.value == null){
        return []
      }
      let ids = Object.assign([], this.value)
      return this.opciones.filter(item => {
        return ids.indexOf(item.id) > -1
      })
    },
    setSelected(selected) {
      let selecteds = Object.assign([], this.value)
      let index = selecteds.indexOf(selected.id)
      if(index > -1){
        selecteds.splice(index, 1)
      }
      else{
        selecteds.push(selected.id)
      }
      this.$emit("input", selecteds)
      // this.generatePlaces()
      // this.change()
    },
    // setSelecteds(selecteds) {
    //   for (let k in selecteds) {
    //     for (let i in this.datos) {
    //       if (selecteds[k].key === this.datos[i].key) {
    //         this.datos[i].checked = true
    //         break
    //       }
    //     }
    //   }
      // this.generatePlaces()
      // this.$forceUpdate()
    // },
    // reset() {
    //   for (let i in this.datos) {
    //     this.datos[i].checked = false
    //   }
      // this.generatePlaces()
      // this.$forceUpdate()
      // this.change()
    // },
    // getSelecteds() {
    //   return this.datos
    //     .filter(function (dt) {
    //       return dt.checked
    //     })
    //     .map(function (dt) {
    //       return dt.key
    //     })
    // },
    // generatePlaces() {
    //   this.placeholderText = this.datos
    //     .filter(function (dt) {
    //       return dt.checked
    //     })
    //     .reduce(function (place, dt) {
    //       return (place += '' + dt.titulo + ', ')
    //     }, '')
    //
    //   this.placeholderText = this.placeholderText.substring(0, this.placeholderText.length - 2)
    //
    //   if (this.placeholderText === '') {
    //     this.placeholderText = this.placeholder
    //   }
    // },
  }
}
</script>

<style lang="scss">
.combobox-vue-special.select-search {
  text-align: left;
  width: 100%;
  max-width: 100%;
  .content-checks {
    cursor: pointer;
    width: 100%;

    position: relative;
    .text-aux {
      max-width: 100%;
      color: #2c3e50;
      background: transparent;
      border-radius: 3px;
      .content-text {
        width: 100%;
          height: 38.19px;
        max-width: 100%;
        padding: .475rem .75rem;
        background-color: #fff;
        border: 1px solid #e9edf4;
        border-radius: 7px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        display: flex;
        align-items: center;
        p {
          max-width: 100%;
          overflow: hidden;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0;
          font-size: 0.875rem;
          font-weight: 400;
          color: #4d5875;
          line-height: 15px;
        }
      }
    }
    .btn-buscar {
      border-radius: 0 50px 50px 0;
      outline: none;
      background: var(--primary-bg-color);
      position: absolute;
      right: 0;
      top: 0;
      color: #fff;
      font-size: 16px;
      width: 60px;
      height: 38px;
      text-transform: uppercase;
      padding: 0 20px 0 15px;
      font-weight: bold;
      border: none;
    }
    .items-list {
      margin: 0;
      position: absolute;
      top: 100%;
      text-align: left;
      left: 50%;
      width: 100%;
      max-height: 350px;
      transform: translateX(-50%);
      border: 1px solid #f0f0f0;
      border-radius: 3px;
      overflow-y: auto;
      width: 100%;
      background: #fff;
      padding: 0;
      list-style: none;
      z-index: 2;
      transition-duration: 0.3s;
      -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.25);
      -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.25);
      box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.25);
      //&::-webkit-scrollbar {
      //  width: 12px;
      //}
      //&::-webkit-scrollbar-track {
      //  background: rgba(0, 0, 0, 0.2);
      //}
      //&::-webkit-scrollbar-thumb {
      //  background: #555;
      //  &:hover {
      //    background: #444;
      //  }
      //}
      .item {
        width: 100%;
        cursor: pointer;
        div {
          position: relative;
          cursor: pointer;
          transition-duration: 0.2s;
          border-bottom: 1px solid #f0f0f0;
          p {
            position: relative;
            z-index: 4;
            display: block;
            margin: 0;
            padding: 10px 15px 10px 40px;
          }
        }
        &:hover {
          div {
            background: #f0f0f0;
          }
        }
      }
      .item.active {
        div {
          background: #f0f0f0;
        }
      }
    }
    .items-list.show {
      visibility: visible;
      opacity: 1;
    }
    .checkbox-item {
      display: inline-block;
      color: rgb(30 30 30 / 1);
      cursor: pointer;
      z-index: 2;
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      span {
        display: inline-block;
        position: relative;
        background-color: transparent;
        width: 20px;
        height: 20px;
        transform-origin: center;
        border: 2px solid var(--primary-bg-color);
        border-radius: 50%;
        vertical-align: -6px;
        margin-right: 10px;
        transition: background-color 150ms 200ms,
          transform 350ms cubic-bezier(0.78, -1.22, 0.17, 1.89);
        &:before {
          content: '';
          width: 0px;
          height: 2px;
          border-radius: 2px;
          background: var(--primary-bg-color);
          position: absolute;
          transform: rotate(45deg);
          top: 8px;
          left: 4px;
          transition: width 50ms ease 50ms;
          transform-origin: 0% 0%;
        }
        &:after {
          content: '';
          width: 0;
          height: 2px;
          border-radius: 2px;
          background: var(--primary-bg-color);
          position: absolute;
          transform: rotate(305deg);
          top: 11px;
          left: 6px;
          transition: width 50ms ease;
          transform-origin: 0% 0%;
        }
      }
      &:hover {
        span {
          &:before {
            width: 5px;
            transition: width 100ms ease;
          }
          &:after {
            width: 10px;
            transition: width 150ms ease 100ms;
          }
        }
      }
    }
    input[type='checkbox'] {
      display: none;
      &:checked {
        + {
          span {
            background-color: var(--primary-bg-color);
            &:after {
              width: 10px;
              background: #fff;
              transition: width 150ms ease 100ms;
            }
            &:before {
              width: 5px;
              background: #fff;
              transition: width 150ms ease 100ms;
            }
          }
        }
        &:hover {
          span {
            background-color: var(--primary-bg-color);
            &:after {
              width: 10px;
              background: #fff;
              transition: width 150ms ease 100ms;
            }
            &:before {
              width: 5px;
              background: #fff;
              transition: width 150ms ease 100ms;
            }
          }
        }
      }
    }
  }
}
</style>
